import { Pipe, PipeTransform } from '@angular/core';
import { LandingPageListingCourseStatusEnum } from 'app/library/landing-page-component/enums/landing-page-listing-course-status.enum';

@Pipe({
    name: 'listingCourseStatusLabel',
})
export class ListingCourseStatusLabelPipe implements PipeTransform {
    transform(status: string | null): string {
        if (status === LandingPageListingCourseStatusEnum.Confirmed) {
            return 'LISTINGS.COURSE_STATUS.CONFIRMED';
        }
        if (status === LandingPageListingCourseStatusEnum.NotConfirmed) {
            return 'LISTINGS.COURSE_STATUS.NOT_CONFIRMED';
        }
        if (status === LandingPageListingCourseStatusEnum.Canceled) {
            return 'LISTINGS.COURSE_STATUS.CANCELED';
        }
        return status || '-';
    }
}
